import React, { useState, useEffect } from "react";
import { totalHoursPassedFromNow, getNHoursAgoAsSeconds } from "../../../utils/date.js";
import "react-intl";
import { ValueRangeFilter } from "./ValueRangeFilter.js";
function HoursRangeFilter({ value, onChange, ...props }) {
  const [currentValue, setCurrentValue] = useState(convertRangeSecondsInHours(value));
  useEffect(() => {
    setCurrentValue(convertRangeSecondsInHours(value));
  }, [`${value?.from}-${value?.to}`]);
  function handleChange(value2) {
    onChange(convertRangeHoursInSeconds(value2));
  }
  function convertRangeSecondsInHours(value2) {
    const getValue = (v) => Number(totalHoursPassedFromNow(`${v}`));
    const from = getValue(value2?.to);
    const to = getValue(value2?.from);
    return { from, to };
  }
  function convertRangeHoursInSeconds({ from, to }) {
    return {
      from: !to || Number.isNaN(Number(to)) || Number(to) < 0 ? null : getNHoursAgoAsSeconds(to),
      to: !from || Number.isNaN(Number(from)) || Number(from) < 0 ? "now" : getNHoursAgoAsSeconds(from)
    };
  }
  return /* @__PURE__ */ React.createElement(ValueRangeFilter, { value: currentValue, onChange: handleChange, ...props });
}
export {
  HoursRangeFilter
};
//# sourceMappingURL=HoursRangeFilter.js.map
